/**
 * Text the person reads in the page's approval card comes from the model (a
 * command, a folder, a message), so it is shown as it is but with the
 * characters that would hide or reorder it made visible: control and format
 * characters, escape sequences and Unicode bidi overrides, every space but the
 * plain one, and characters that show with no width, such as tag characters,
 * variation selectors, the soft hyphen and the Hangul filler, become their
 * escaped form. A no-break space looks like a space, but a shell does not
 * split on it, so `npm test<no-break space>#; curl … | sh` would read as a
 * test run with a comment while the shell runs `curl`. Tabs and line breaks
 * stay, because a command can span lines; the card shows each one.
 */

// Unicode properties name the classes, so the source holds no raw line separator, which would end
// a regex literal. U+2800, the blank Braille pattern, shows as a space but is a symbol.
const HIDDEN = /(?![\t\n ])[\p{Cc}\p{Cf}\p{Z}\p{Default_Ignorable_Code_Point}\u2800]/gu;

/** A character as `\uXXXX`, or as `\u{XXXXX}` above U+FFFF. */
function escaped(character: string) {
  const code = character.codePointAt(0) ?? 0;
  const hex = code.toString(16).toUpperCase();
  return code > 0xffff ? `\\u{${hex}}` : `\\u${hex.padStart(4, '0')}`;
}

export function dialogText(text: string): string {
  return text.replace(/\r\n?/g, '\n').replace(HIDDEN, escaped);
}

/**
 * The lines the card shows, whole: a cut line would hide the end of a command
 * from the person approving it, and the card wraps long lines itself.
 */
export function dialogLines(text: string): string[] {
  return dialogText(text).split('\n');
}
